
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { getToken } from '@/functions/token.function';
import { Prop } from "vue-property-decorator";
import { CourseLevelEnum, EnumHelper } from "@/constants/enum.constant";
import _ from "lodash";

@Component({
  components: {},
  filters,
})
export default class CourseItem extends Vue {
  @Prop({ default: false, type: Boolean })
  private isBundle!: boolean;
  @Prop({ default: true, type: Boolean })
  private stats!: boolean;
  @Prop({ default: null, type: Object })
  private bundle!: any;
  @Prop({ default: null, type: Object })
  private course!: any;
  

  private levels = EnumHelper(CourseLevelEnum);

  private get availableToken() {
		return getToken();
	}

  private get contentsCount() {
    if (this.isBundle) {
      return _.sum(this.bundle?.courses.map((course) => course.contents_count));
    }

    return this.course?.contents_count;
  }
  private get transactionsCount() {
    if (this.isBundle) {
      return this.bundle?.transactions_count;
    }

    return this.course?.transactions_count;
  }
  private get level() {
    if (this.isBundle) {
      return this.levels.find(
        (value) =>
          value.id ===
          Math.max(...this.bundle?.courses.map((course) => course.level))
      )?.name;
    }

    return this.levels.find((value) => value.id === this.course?.level)?.name;
  }
  private get rating() {
    if (this.isBundle) {
      return parseFloat(this.bundle?.rating) || 0;
    }

    return parseFloat(this.course?.ratings_avg_rating) || 0;
  }

 private get areAllCoursesFree() {
  if (this.isBundle) {
    return (
      this.bundle?.courses?.length > 0 &&
      this.bundle.courses.every(
        (course: any) =>
          course.paid ||
          course.price === 0 ||
          course.offer_price === 0 ||
          course.price === 2 ||
          course.offer_price === 2
      )
    );
  }
  return false;
}

  private detail() {
    if (this.isBundle) {
      this.$router.push({
        name: "bundle-course-detail",
        params: {
          slug: this.bundle?.slug,
        },
      });
    } else {
      this.$router.push({
        name: "course-detail",
        params: {
          slug: this.course?.slug,
        },
      });
    }
  }
}
